import * as actionType from "./actionTypes";

//Adds to the cart and opens the cart drawer so the customer sees it land. options: e.g. { Color: "Gold" }
export const addItem = (sku, options={}, quantity=1, openDrawer=true) => (
  (dispatch) => {
    dispatch({
      type: actionType.ADD_ITEM,
      sku,
      options,
      quantity,
    });
    if (openDrawer) {
      dispatch(setDrawerOpen(true));
    }
  }
);

//key: the line's getLineKey
export const setQuantity = (key, quantity) => (
  {
    type: actionType.SET_QUANTITY,
    key,
    quantity,
  }
);

export const removeItem = (key) => (
  {
    type: actionType.REMOVE_ITEM,
    key,
  }
);

//Removes lines for products no longer for sale, or whose options have changed. isAvailable: (item) => bool
export const removeUnavailable = (isAvailable) => (
  {
    type: actionType.REMOVE_UNAVAILABLE,
    isAvailable,
  }
);

export const clear = () => (
  {
    type: actionType.CLEAR,
  }
);

export const setDrawerOpen = (isOpen) => (
  {
    type: actionType.SET_DRAWER_OPEN,
    isOpen,
  }
);
